<template>
  <div>
    <div v-if="loading">
      <b-spinner
                 variant="primary"
                 style="width: 3rem; height: 3rem"
                 label="Large Spinner"></b-spinner>
    </div>

    <div v-if="!loading && reps.length > 0">
      <!-- Branch selection -->
      <div class="row" v-if="!selectedBranch">
        <div class="col-12">
          <h4>Select Branch:</h4>
        </div>
        <div
             class="col-6 col-md-3 mt-3"
             v-for="branch in reps"
             :key="branch.id">
          <div
               class="card is-link-card p-3 text-center h-100"
               v-if="branch.branch"
               @click="selectedBranch = branch.branch">
            <strong class="text-primary">{{ branch.branch.code }}</strong>
            <small class="font-size-11 text-muted">{{
              branch.branch.name
            }}</small>
          </div>
        </div>
      </div>

      <!-- Customers -->
      <div
           class="row"
           v-show="selectedBranch != null && selectedCustomer == null">
        <div class="col-12">
          <input
                 ref="customerquotationsearch"
                 type="text"
                 class="form-control"
                 style="max-width: 200px"
                 placeholder="search customers"
                 @keyup="filterCustomers($event)" />
        </div>

        <div
             class="col text-muted my-3"
             v-if="branchCustomers.filter((x) => !x.hidden).length == 0">
          No Customers allocated -
          <span @click="reset" class="text-success pointer">Reset</span>
        </div>

        <div
             class="col-6 col-md-4 col-lg-3 mt-3"
             v-for="customer in branchCustomers.filter((x) => !x.hidden)"
             :key="customer.id">
          <div class="card is-link-card p-2 text-center h-100">
            <div @click="selectedCustomer = customer">
              <strong>{{ customer.name }}</strong><br />
              <small class="text-black-50">{{ customer.trading_as }}</small>
              <p>{{ customer.area }}</p>
            </div>
            <div class="pointer text-primary">
              BAL {{ customer.current_balance | currency }}
              <br />
              <span
                    class="badge badge-primary"
                    @click="viewCustomer(customer.id)">View Balances</span>
            </div>
          </div>
        </div>
      </div>

      <!-- quotation -->
      <div v-if="selectedBranch != null && selectedCustomer != null">
        <div class="row">
          <div class="col">
            <div class="card maxWidth1000 box-shadow border">
              <div class="card-header bg-dark text-white no-round">
                <div class="row">
                  <div class="col">
                    <strong>{{ selectedBranch.name }} </strong><br />
                    <h4 v-if="selectedCustomer">{{ selectedCustomer.name }}</h4>
                  </div>
                </div>
              </div>
              <div class="card-body p-0">
                <div class="row" v-if="quotation.products.length == 0">
                  <div class="col text-muted m-5">No products addded</div>
                </div>

                <div v-if="quotation.products.length > 0" class="row font-size-13">
                  <div class="col-12">
                    <table class="table table-striped table-sm">
                      <thead>
                        <tr class="bg-dark text-white font-size-13 l-s-1">
                          <th>NAME</th>
                          <th class="text-center">PRICE</th>
                          <th class="text-center">MASS</th>
                          <th class="text-right"></th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="product in quotation.products" :key="product.id">
                          <td>
                            {{ product.name }} <br>
                            MIN (Mandate):<span class="text-info">{{ product.price_min }}</span> MAX (List Price):<span
                                  class="text-info">{{ product.price_max }}</span>
                          </td>


                          <td class="text-center text-nowrap">

                            <span class="table-action-icon p-1 bg-info text-white"
                                  @click="productPriceDecrease(product.product_id)">
                              <i
                                 class="
                                lni lni-minus
                              "></i>
                            </span>
                            &nbsp;
                            <strong>{{
                              parseFloat(product.price).toFixed(2) | currency
                            }}
                            </strong>
                            &nbsp;
                            <span class="table-action-icon p-1 bg-info text-white"
                                  @click="productPriceIncrease(product.product_id)">
                              <i
                                 class="
                                lni lni-plus
                              "></i>
                            </span>
                          </td>

                          <td class="text-center">
                            <span v-if="product.price_extended_by_mass == 1">
                              {{ product.average_mass }}
                            </span>
                          </td>



                          <td class="text-right">
                            <i
                               class="
                                lni lni-cross-circle
                                text-danger
                                mt-2
                                pointer
                              "
                               @click="removeProduct(product)"></i>
                          </td>
                        </tr>

                      </tbody>
                    </table>
                  </div>
                </div>


              </div>

              <div class="card-footer bg-dark no-round">
                <button class="btn btn-danger" @click="reset()">
                  <i class="lni lni-trash m-0"></i>
                </button>

                <button
                        v-show="quotation.products.length > 0"
                        class="btn btn-success float-right ml-1"
                        @click="handleSubmit()">
                  PDF
                </button>

                <button
                        class="btn btn-primary float-right"
                        @click="addProductModalShow = true">
                  <i class="lni lni-circle-plus m-0"></i> Add
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Product selection modal -->
      <b-modal
               @shown="focusGroupSearch"
               :title="selectedGroup == null ? 'Group Selection' : selectedGroup.name"
               :hide-footer="true"
               size="lg"
               v-model="addProductModalShow"
               @hidden="selectedGroup = null">
        <!-- group select -->
        <div v-show="selectedGroup == null">
          <div class="row">
            <div class="col-12">
              <input
                     ref="groupquotationsearch"
                     v-model="groupSearchText"
                     type="text"
                     class="form-control"
                     style="max-width: 200px"
                     placeholder="search groups"
                     @keyup="filterGroups($event)" />
            </div>
          </div>

          <div
               class="col text-muted my-3"
               v-if="productGroups.filter((x) => !x.hidden).length == 0">
            No Groups found
            <span v-if="groupSearchText && groupSearchText.length > 0">matching {{ groupSearchText }}</span>
          </div>

          <div class="row" :key="groupKey">
            <div
                 class="col-6 col-sm-4 col-lg-3 mt-3"
                 v-for="group in productGroups.filter((x) => !x.hidden)"
                 :key="group.id">
              <div
                   class="card border is-link-card text-center"
                   :style="'height: 90px;background-size:cover;background-position:center;background-image:url(' +
                    group.image +
                    ');'
                    "
                   @click="selectedGroup = group">
                <strong class="bg-dark text-white p-1 my-auto mx-auto">{{
                  group.name
                }}</strong>
              </div>
            </div>
          </div>
        </div>

        <!-- product select -->
        <div v-if="selectedGroup != null">
          <div class="row">
            <div class="col-12">
              <input
                     ref="productquotationsearch"
                     type="text"
                     class="form-control float-left"
                     style="max-width: 200px"
                     placeholder="search products"
                     @keyup="filterProducts($event)" />
              <button
                      class="btn btn-primary btn-sm float-right"
                      @click="selectedGroup = null; filterProducts(null)">
                <i class="lni lni-arrow-left-circle m-0"></i>
              </button>
            </div>
          </div>
          <div class="row" :key="productKey">
            <div
                 class="col text-muted my-3"
                 v-if="
                  products.filter(
                    (x) => !x.hidden && x.product_group_id == selectedGroup.id
                  ).length == 0
                ">
              No Products found
            </div>

            <div class="col">
              <div
                   v-for="product in products.filter(
                    (x) => !x.hidden && x.product_group_id == selectedGroup.id
                  )"
                   :key="product.id"
                   class="card border is-link-card mt-1"
                   :class="{ 'bg-light-green': product.on_promotion == 1 }"
                   @click="selectProduct(product)">
                <div class="card-body px-1 py-1">
                  <div class="row no-gutters">
                    <div class="col-3 l-h-1">
                      <span
                            class="font-weight-bold font-size-11 "
                            :class="{
                              'text-success blink-me': product.on_promotion == 1,
                            }">{{ product.code }}</span>
                      <span class="font-size-11" v-if="product.average_mass"><br>{{ product.average_mass }} kg</span>
                    </div>
                    <div class="col-6 l-h-1">
                      <span class="font-weight-bold font-size-11">{{
                        product.name
                      }}</span>
                      <br />
                      <small class="text-muted font-size-11">{{
                        product.brand.name
                      }}</small>
                    </div>
                    <div class="col-3 text-right font-weight-bold font-size-11">
                      {{ product.mandate_pricing_min | currency }}
                      <br />
                      <small class="text-muted font-size-11">{{ product.mandate_pricing_max | currency }}
                      </small>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </b-modal>

      <!-- Product Add modal -->
      <b-modal
               size="lg"
               :title="selectedProduct != null ? selectedProduct.name : ''"
               :hide-footer="true"
               v-model="productSelectedModalShow"
               @hidden="
                selectedProduct = null;
              selectedPrice = null;
              "
>
        <div
             class="row mx-auto" style="max-width:500px;"
             v-show="selectedProduct != null"
             :key="productImageKey">
          <div class="col">
            <form @submit.prevent="addProduct()">
              <div class="row" v-if="selectedProduct != null">
                <div class="col">
                  <div class="border w-50 p-2 float-left">
                    <small class="text-muted">MIN (Mandate)</small>
                    <h6 class="font-weight-bold text-primary">
                      {{ selectedProduct.mandate_pricing_min | currency }}
                    </h6>
                  </div>
                  <div
                       class="border w-50 p-2 float-left"
                       v-show="selectedProduct.mandate_pricing_max != null">
                    <small class="text-muted">MAX (List Price)</small>
                    <h6 class="font-weight-bold text-danger">
                      {{ selectedProduct.mandate_pricing_max | currency }}
                    </h6>
                  </div>
                </div>
              </div>

              <div class="border bg-light p-2 mb-2">
                <div class="row">

                  <div class="col-8 mx-auto">
                    <small class="font-size-9 text-muted font-weight-bold">PRICE</small>
                    <b-form-spinbutton
                                       locale="en"
                                       v-model="selectedPrice"
                                       step="0.01"
                                       min="0"
                                       max="1000000"></b-form-spinbutton>

                    <div></div>

                    <div
                         class="btn-group bg-white border d-flex"
                         role="group"
                         style="padding: 3px">
                      <span
                            class="btn btn-light btn-sm font-size-11"
                            @click="selectedPrice -= 0.05"><i class="lni lni-minus m-0"></i></span>
                      <span class="btn btn-link btn-sm font-size-11 w-100">5c</span>

                      <span
                            class="btn btn-light btn-sm font-size-11"
                            @click="selectedPrice += 0.05"><i class="lni lni-plus m-0"></i></span>
                    </div>

                    <div
                         class="btn-group bg-white border d-flex"
                         role="group"
                         style="padding: 3px">
                      <span
                            class="btn btn-light btn-sm font-size-11"
                            @click="selectedPrice -= 0.10"><i class="lni lni-minus m-0"></i></span>
                      <span class="btn btn-link btn-sm font-size-11 w-100">10c</span>

                      <span
                            class="btn btn-light btn-sm font-size-11"
                            @click="selectedPrice += 0.10"><i class="lni lni-plus m-0"></i></span>
                    </div>

                    <div
                         class="btn-group bg-white border d-flex"
                         role="group"
                         style="padding: 3px">
                      <span
                            class="btn btn-light btn-sm font-size-11"
                            @click="selectedPrice -= 0.5"><i class="lni lni-minus m-0"></i></span>
                      <span class="btn btn-link btn-sm font-size-11 w-100">50c</span>

                      <span
                            class="btn btn-light btn-sm font-size-11"
                            @click="selectedPrice += 0.5"><i class="lni lni-plus m-0"></i></span>
                    </div>
                    <div
                         class="btn-group bg-white border d-flex"
                         role="group"
                         style="padding: 3px">
                      <span
                            class="btn btn-light btn-sm font-size-11"
                            @click="selectedPrice -= 1.0"><i class="lni lni-minus m-0"></i></span>

                      <span class="btn btn-link btn-sm font-size-11 w-100">R1</span>
                      <span
                            class="btn btn-light btn-sm font-size-11"
                            @click="selectedPrice += 1.0"><i class="lni lni-plus m-0"></i></span>
                    </div>
                  </div>
                </div>


                <button
                        class="btn btn-success btn-sm btn-block mt-3"
                        type="submit">
                  Add
                </button>

              </div>
            </form>

            <div class="row border-top pt-2" v-if="selectedProduct != null">
              <div class="col-8">
                <p class="m-0 font-weight-bold">{{ selectedProduct.code }}</p>
                <h5 class="mt-0 mb-3">{{ selectedProduct.name }}</h5>
              </div>
              <div class="col-4 text-center text-md-right">
                <img
                     v-if="selectedProduct != null && selectedProduct.image"
                     :src="selectedProduct.image"
                     class="img-fluid maxHeight200" />
              </div>
            </div>

            <table class="table table-sm mt-2" v-if="selectedProduct != null">
              <table-row :no-border="true" label="Description">{{
                selectedProduct.description
              }}</table-row>

              <table-row label="Average Mass" v-if="selectedProduct.average_mass">{{ selectedProduct.average_mass }} kg
                <span class="badge badge-primary" v-if="selectedProduct.price_extended_by_mass == 1">Extended</span>
              </table-row>

              <table-row label="Cases Per Pallet">{{ selectedProduct.cases_per_pallet }}
              </table-row>

              <table-row label="Supplier">{{ selectedProduct.supplier.name }}
              </table-row>
              <table-row label="Brand">{{ selectedProduct.brand.name }}
              </table-row>
            </table>

            <div class="row my-3" v-if="selectedProduct != null">
              <div class="col-12">
                <div class="border">
                  <div v-if="loading">
                    <b-spinner
                               variant="primary"
                               style="width: 3rem; height: 3rem"
                               label="Large Spinner"></b-spinner>
                  </div>

                  <div
                       v-for="comment in selectedProduct.product_comments"
                       :key="comment.id"
                       class="card border-bottom p-2 mb-1">
                    <p class="nl2br">
                      {{ comment.comment }}
                    </p>

                    <a
                       v-if="comment.file_url"
                       :href="comment.file_url"
                       target="new">
                      {{ comment.file_description }}<br />
                    </a>

                    <img
                         v-if="comment.image"
                         :src="comment.image"
                         class="img-fluid maxWidth500 my-2" />

                    <div class="row">
                      <div class="col-auto">
                        <b-avatar v-if="!comment.user.image"></b-avatar>
                        <b-avatar
                                  v-if="comment.user.image"
                                  :src="comment.user.image"></b-avatar>
                      </div>
                      <div class="col">
                        <h6 class="mb-0 mt-1 font-weight-bold">
                          {{ comment.user.name }}
                        </h6>
                        <small class="text-muted">
                          <i class="lni lni-calendar"></i>
                          {{
                            moment(new Date(comment.created_at)).format(
                              "DD MMM YYYY, HH:mm:ss"
                            )
                          }}

                          |

                          {{
                            moment
                              .duration(
                                moment(Date.now()).diff(
                                  moment(new Date(comment.created_at)),
                                  "seconds"
                                ),
                                "seconds"
                              )
                              .format("Y [year] D [day], H [hour &] m [min]")
                          }}
                          ago
                        </small>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </b-modal>

      <!-- AGging Balances -->
      <b-modal
               title="Customer Balance"
               :hide-footer="true"
               v-model="customerBalanceModal">
        <div class="row">
          <div class="col">
            <table class="table table-sm">
              <table-row label="Updated On" class="font-weight-bold">{{
                moment(new Date(balanceUpdatedOn)).format(
                  "DD MMM YYYY, HH:mm:ss"
                )
              }}</table-row>
              <table-row label="Balance" class="font-weight-bold">{{
                currentBalance | currency
              }}</table-row>

              <table-row label=""> &nbsp;<br /> </table-row>

              <table-row label="Credit Limit">{{
                creditLimit | currency
              }}</table-row>

              <table-row label="Max Credit">{{
                maxCreditLimit | currency
              }}</table-row>

              <table-row label=""> &nbsp;<br /> </table-row>

              <table-row label="Aging Current">{{
                agingCurrent | currency
              }}</table-row>

              <table-row label="Aging 30">{{ aging30 | currency }}</table-row>

              <table-row label="Aging 60" class="text-info">{{
                aging60 | currency
              }}</table-row>

              <table-row label="Aging 90" class="text-warning">{{
                aging90 | currency
              }}</table-row>

              <table-row label="Aging 90+" class="text-danger">{{
                aging90Plus | currency
              }}</table-row>
            </table>
          </div>
        </div>
      </b-modal>
    </div>
  </div>
</template>

<script>
import customerBranchPricing, { productsForBranch } from "@/mixins/customerBranchPricing";
import quotationRepo from "@/api/repos/quotationRepo";
import tableRow from "@/components/common/TableRow";

export default {
  mixins: [customerBranchPricing],
  components: {
    tableRow,
  },

  mounted() {
    this.getData();
  },

  data() {
    return {
      quotation: {
        products: [],
      },
      reps: [],
      productGroups: [],
      brands: [],
      customer: [],
      suppliers: [],
      loading: false,
      errors: null,
      submitStatus: null,
      selectedBranch: null,
      selectedGroup: null,
      selectedCustomer: null,
      historyRequestId: 0,
      branchCustomers: [],
      groupKey: 1,
      productKey: 1,
      productImageKey: 1,
      addProductModalShow: false,
      productSelectedModalShow: false,
      selectedProduct: null,
      selectedPrice: null,
      groupSearchText: null,
      customerBalanceModal: false,
      agingCurrent: 0,
      aging30: 0,
      aging60: 0,
      aging90: 0,
      aging90Plus: 0,
      currentBalance: "-",
      creditLimit: "-",
      maxCreditLimit: "-",
      balanceUpdatedOn: "-",
    };
  },

  methods: {
    async getData() {
      try {
        let { data } = await quotationRepo.createGetDataPricelist(0);
        this.baseProducts = data.products;
        this.productGroups = data.product_groups;
        this.suppliers = data.suppliers;
        this.brands = data.brands;
        this.reps = data.reps;
        this.customers = data.customers;

        this.productGroups.forEach((x) => (x.hidden = false));
        this.products.forEach((x) => (x.hidden = false));

        if (this.reps.length == 0) {
          this.$root.$bvToast.toast(
            "You are not allocated as a REP to any branches.",
            {
              title: "No Reps Branch Relations",
              autoHideDelay: 3000,
              variant: "danger",
            }
          );
        }
      } catch (error) {
        console.log(error);
      }
    },

    handleSubmit() {
      this.$bvModal
        .msgBoxConfirm("Please confirm that you want to finalize the pricelist?", {
          title: "Please Confirm",
          size: "sm",
          buttonSize: "sm",
          okVariant: "success",
          okTitle: "YES",
          cancelTitle: "NO",
          footerClass: "p-2",
          hideHeaderClose: false,
          centered: true,
        })
        .then((confirm) => {
          if (confirm) {
            this.submitQuotation();
          }
        })
        .catch((error) => console.log(error));
    },

    async submitQuotation() {
      this.loading = true;

      if(this.quotation.products.length == 0){
        this.loading = false;
      }else{

        var str = this.selectedCustomer.id+"-";

        this.quotation.products.forEach(function(p){
          str += p.code+"("+parseFloat(p.price).toFixed(2)+"),"
        })

        str = str.slice(0, -1);

        try {
          let response = await quotationRepo.createPricelist(str);
          var fileURL = window.URL.createObjectURL(new Blob([response.data]));
          var fileLink = document.createElement("a");

          fileLink.href = fileURL;
          fileLink.setAttribute("download", `pricelist.pdf`);
          document.body.appendChild(fileLink);

          fileLink.click();
        } catch (error) {
          console.log(error);
          this.loading = false;
        } finally {
          this.selectedBranch = null;
            this.selectedGroup = null;
            this.quotation = {
              products: [],
            };
            this.selectedCustomer = null;
            this.branchCustomers = [];
          this.loading = false;
        }
      }

    },

    reset() {
      this.$bvModal
        .msgBoxConfirm("Please confirm that you want reset?", {
          title: "Please Confirm",
          size: "sm",
          buttonSize: "sm",
          okVariant: "danger",
          okTitle: "YES",
          cancelTitle: "NO",
          footerClass: "p-2",
          hideHeaderClose: false,
          centered: true,
        })
        .then((confirm) => {
          if (confirm) {
            this.selectedBranch = null;
            this.selectedGroup = null;
            this.quotation = {
              products: [],
            };
            this.selectedCustomer = null;
            this.branchCustomers = [];
          }
        })
        .catch((error) => console.log(error));
    },

    filterCustomers(e) {
      let q = e.target.value;

      this.branchCustomers.forEach((x) => {
        if (x.name != null) {
          if (x.name.toLowerCase().includes(q.toLowerCase())) {
            x.hidden = false;
          } else {
            x.hidden = true;
          }
        }

        if (x.trading_as != null && x.hidden) {
          if (x.trading_as.toLowerCase().includes(q.toLowerCase())) {
            x.hidden = false;
          }
        }

        if (x.area != null && x.hidden) {
          if (x.area.toLowerCase().includes(q.toLowerCase())) {
            x.hidden = false;
          }
        }
      });
    },

    filterGroups(e) {
      let q = e.target.value;

      this.productGroups.forEach((x) => {
        if (x.name != null) {
          if (x.name.toLowerCase().includes(q.toLowerCase())) {
            x.hidden = false;
          } else {
            x.hidden = true;
          }
        } else {
          x.hidden = true;
        }
      });

      this.groupKey++;
    },

    filterProducts(e) {

      if (e == null) {
        //reset show all again
        this.products.forEach((x) => {
          x.hidden = false;
        })
      } else {

        let q = e.target.value;

        this.products.forEach((x) => {
          if (x.name != null) {
            if (x.name.toLowerCase().includes(q.toLowerCase())) {
              x.hidden = false;
            } else {
              x.hidden = true;
            }
          }

          if (x.code != null && x.hidden) {
            if (x.code.toLowerCase().includes(q.toLowerCase())) {
              x.hidden = false;
            }
          }

          if (x.brand.name != null && x.hidden) {
            if (x.brand.name.toLowerCase().includes(q.toLowerCase())) {
              x.hidden = false;
            }
          }

          if (x.supplier.name != null && x.hidden) {
            if (x.supplier.name.toLowerCase().includes(q.toLowerCase())) {
              x.hidden = false;
            }
          }
        });
      }

      this.productKey++;
    },

    focusGroupSearch() {
      // this.$refs.groupquotationsearch.focus();
    },

    selectProduct(product) {
      this.selectedProduct = product;
      this.selectedPrice = parseFloat(product.mandate_pricing_min);
      this.productSelectedModalShow = true;
      this.productImageKey++;
      this.filterProducts(null)
    },

    addProduct() {
      if (
        this.selectedPrice == null ||
        this.selectedProduct == null ||
        this.selectedPrice <= 0
      ) {
        this.$root.$bvToast.toast("Please fill in required fields", {
          title: "Errors on form data",
          autoHideDelay: 3000,
          variant: "danger",
        });
        return false;
      }


      var price = parseFloat(this.selectedPrice.toString().replace(",", "."));

      this.quotation.products.push({
        uid: Date.now(),
        code: this.selectedProduct.code,
        product_id: this.selectedProduct.id,
        name: this.selectedProduct.name,
        average_mass: this.selectedProduct.average_mass,
        price_extended_by_mass: this.selectedProduct.price_extended_by_mass,
        price_min: this.selectedProduct.mandate_pricing_min,
        price_max:this.selectedProduct.mandate_pricing_max,
        price: price,
      });


      this.selectedProduct = null;
      this.selectedGroup = null;
      this.productSelectedModalShow = false;
      this.addProductModalShow = false;
      this.selectedPrice = null;
      this.groupSearchText = null;
      this.productGroups.forEach((x) => (x.hidden = false));

      this.$root.$bvToast.toast("Product Added", {
        title: "Success",
        autoHideDelay: 1000,
        variant: "success",
      });
    },


    removeProduct(product) {
      this.$bvModal
        .msgBoxConfirm("Please confirm that you want to delete the line", {
          title: "Please Confirm",
          size: "sm",
          buttonSize: "sm",
          okVariant: "danger",
          okTitle: "YES",
          cancelTitle: "NO",
          footerClass: "p-2",
          hideHeaderClose: false,
          centered: true,
        })
        .then((confirm) => {
          if (confirm) {


            this.quotation.products = this.quotation.products.filter(
              (x) => x.uid != product.uid
            );

          }
        })
        .catch((error) => console.log(error));
    },

    viewCustomer(id) {
      this.customerBalanceModal = true;
      this.customers.forEach((c) => {
        if (c.id == id) {
          this.agingCurrent = c.aging_current;
          this.aging30 = c.aging_30;
          this.aging60 = c.aging_60;
          this.aging90 = c.aging_90;
          this.aging90Plus = c.aging_90_plus;
          this.currentBalance = c.current_balance;
          this.creditLimit = c.credit_limit;
          this.maxCreditLimit = c.max_credit_limit;
          this.balanceUpdatedOn = c.updated_at;
        }
      });
    },

    productPriceIncrease(id) {   
      this.quotation.products.forEach(x => {
        if(x.product_id == id){
          x.price = parseFloat(x.price) + 0.05;
        }
      })
    },
    productPriceDecrease(id) {
      this.quotation.products.forEach(x => {
        if(x.product_id == id){
          x.price = parseFloat(x.price) + 0.05;
        }
      })
    }

  },

  computed: {},

  watch: {
    selectedBranch: {
      handler: function () {
        if (this.selectedBranch != null) {
          this.branchCustomers = [];
          this.$nextTick(() => {
            this.$refs.customerquotationsearch.focus();
          });
          this.customers.forEach((e) => {
            if (e.branch_id == this.selectedBranch.id) {
              e.hidden = false;
              this.branchCustomers.push(e);
            }
          });
        }
      },
    },
    selectedCustomer: {
      handler: async function (customer) {
        const requestId = ++this.historyRequestId;
        if (customer != null) {

          let { data } = await quotationRepo.createGetDataPricelist(customer.id);
          if (requestId !== this.historyRequestId || this.selectedCustomer !== customer) return;
          let q = this.quotation;
          productsForBranch(data.products, customer.branch_id).forEach(function (p, i) {

            q.products.push({
              uid: Date.now() + i,
              product_id: p.id,
              price_min: p.mandate_pricing_min,
              price_max: p.mandate_pricing_max,
              code: p.code,
              name: p.name,
              average_mass: p.average_mass,
              price_extended_by_mass: p.price_extended_by_mass,
              price: p.mandate_pricing_min,
            });
          })
        }
      },
    },
  },
};
</script>
